

import React, { memo } from 'react';

import cx from 'classnames';
import ActionButton from '../../ActionButton';
import {
  CLOSE_BUTTON,
  CLOSABLE_PAGE,
  CLOSABLE_PAGE_HEADER,
  CONTENT } from
'../styles';

const MISSING_HISTORY_ERR = 'The History object prop is required in <ClosablePage> when no onClose prop is passed. Pass history down by using the withRouter decorator from react-router-dom.';




















/**
 * A component for rendering a closable page.
 *
 * @param {ClosablePageProps} props
 *
 * @return {React.Element}
 */
function ClosablePage({
  children,
  className,
  pageHeaderClassName,
  actionButtonClassName,
  contentClassName,
  history,
  onClose,
  backUrl,
  backgroundImage,
  isRootPush
}) {
  if (!history && !onClose) {throw new Error(MISSING_HISTORY_ERR);}

  const handleCallback = (func) => func && func();

  const handleClose = () => {
    if (!history) {return void handleCallback(onClose);}

    const { goBack, push, rootPush } = history;

    if (!backUrl) {
      handleCallback(onClose);
      return void goBack();
    }

    const pushAction = isRootPush && rootPush ? rootPush : push;

    handleCallback(onClose);

    pushAction(backUrl);
  };

  return (
    <div className={cx('closable-page', CLOSABLE_PAGE({ backgroundImage }), className)}>
      <div className={cx(
        'closable-page__action-button-wrapper',
        CLOSABLE_PAGE_HEADER({ backgroundImage }),
        pageHeaderClassName
      )}>

        <ActionButton
          className={cx(
            'closable-page__close-btn',
            CLOSE_BUTTON({ backgroundImage }),
            actionButtonClassName
          )}
          icon="close"
          iconColor="regent"
          labelText="Close"
          onClick={handleClose}
          iconSize={15} />

      </div>
      <div className={cx('closable-page__content', CONTENT, contentClassName)}>
        {children}
      </div>
    </div>);

}

ClosablePage.defaultProps = {
  isRootPush: false
};

export default memo(ClosablePage);